import React, { useState } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";

function AddDish() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error(UI_CONSTANTS.TOAST_MESSAGES.VALIDATION.ENTER_DISH_CATEGORY_NAME);
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name.trim())) {
      toast.error("Dish category name should only contain letters and spaces");
      return;
    }

    setLoading(true);
    try {
      const response = await handleApiCall("post", endpoints.addDishCategory, {
        name: formData.name,
      });

      if (response?.data?.code === UI_CONSTANTS.API_CODES.CREATED) {
        toast.success(response?.data?.message || UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.DISH_CATEGORY_ADDED);
        setTimeout(() => {
          navigate(UI_CONSTANTS.ROUTES.DISH_CATEGORIES);
        }, UI_CONSTANTS.TIMEOUTS.REDIRECT_DELAY);
      }
      // Error messages are already handled by handleApiCall
    } catch (error) {
      console.error("Error adding dish category:", error);
      // Network errors or unexpected errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
    });
    navigate(UI_CONSTANTS.ROUTES.DISH_CATEGORIES);
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">{UI_CONSTANTS.PAGE_TITLES.ADD_DISH}</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? UI_CONSTANTS.BUTTON_LABELS.ADDING : UI_CONSTANTS.BUTTON_LABELS.ADD}
                    </Button>
                    <Button type="button" className="rounded-lg ml-4 bg-white" onClick={handleCancel} disabled={loading}>
                      {UI_CONSTANTS.BUTTON_LABELS.CANCEL}
                    </Button>
                  </div>
                </div>
                <h5 className="text-white mt-4 mb-3">{UI_CONSTANTS.SECTION_HEADERS.ADD_DISH_CATEGORY}</h5>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <input
                      type="text"
                      className="form-control default"
                      placeholder={UI_CONSTANTS.PLACEHOLDERS.DISH_CATEGORY_NAME}
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  {/* Commented out other fields as per requirement */}
                  {/* <div className="form-group col-md-8 px-2">
                    <input type="text" className="form-control default" placeholder="Description" />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Price" />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <select className="form-control default">
                      <option>Select Size</option>
                    </select>
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <select className="form-control default">
                      <option>Select Size</option>
                    </select>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddDish;
